import { Link, useParams } from "react-router";

function About() {
  const params = useParams();
  return (
    <div>
      <div><Link to="/">Back</Link></div>

      <p>This is the image page {params.imageId}.</p>
    </div>
  );
}

export default About;
